import { INFINITY_SIGN } from 'consts/common';
import React from 'react';

import Typography from '@libs/ui/components/typography';

import { FormModel } from '../types';
import { useTalentCount } from './hooks';

interface TalentsCountProps {
  values: FormModel;
  scopedCompanyId: string | undefined;
}

export const TalentsCount = ({
  values,
  scopedCompanyId,
}: TalentsCountProps) => {
  const { count, loading } = useTalentCount(values, scopedCompanyId);

  return (
    <Typography
      variant="body2"
      color={loading ? 'text.secondary' : 'text.main'}
    >
      This message will be sent to{' '}
      <Typography component="span" variant="body2" color="tertiary.main">
        {loading ? INFINITY_SIGN : count}
      </Typography>{' '}
      talents
    </Typography>
  );
};
